import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { spacing12 } from 'approot/shared/styles/spacing.style';
import { SecondaryButtonIcon } from 'approot/shared/styles/buttons/secondary-button.style';

type PaginationProps = {
  $isNext?: boolean;
};
export const Pagination = styled(SecondaryButtonIcon).attrs({
  $borderRadius: 40,
})<PaginationProps>`
  position: absolute;
  top: 50%;
  margin-top: -${rem(20)};

  ${({ $isNext }) =>
    $isNext
      ? `
      right: ${rem(spacing12)};
  `
      : `
     left: ${rem(spacing12)};
  `}
`;
